import { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import {
  setSchedulePublicRequestTeacherId,
  setSchedulePublicRequestText,
  setSchedulePublicSearchText,
} from 'entities/index';
import { MAIN_PAGE } from 'shared/consts';
import { useLastSearchQuery } from 'shared/hooks';
import { useAppDispatch } from 'shared/lib';

export const RequireLastSearch = ({ children }: { children: JSX.Element }) => {
  const { getLastSearchQuery } = useLastSearchQuery();
  const lastSearchQuery = getLastSearchQuery();

  const dispatch = useAppDispatch();

  if (!lastSearchQuery) {
    return <Navigate to={MAIN_PAGE} replace />;
  } else {
    dispatch(setSchedulePublicSearchText(lastSearchQuery.requestText));
    dispatch(setSchedulePublicRequestText(lastSearchQuery.requestText));
    if (lastSearchQuery.teacherId) {
      dispatch(setSchedulePublicRequestTeacherId(lastSearchQuery.teacherId));
    }
  }

  return children;
};
